import { Dialog, DialogActions, DialogContent, Drawer, Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { useIntl } from 'react-intl';
import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import AssistantRoundedIcon from '@mui/icons-material/AssistantRounded';
import Fade from '@mui/material/Fade';
import MDButton from 'components/MDButton';
import { NodeFormsFactory } from 'pages/assistants/builder/components/nodeFormsFactory';
import MDTypography from 'components/MDTypography';

function NodeFormDetailsDrawer({ node, drawerOpen, setDrawerOpen, onNodeChanged }) {
  const { formatMessage: msg } = useIntl();
  //const [isFormDirty, setIsFormDirty] = useState(false);
  const [confirmCloseFormDialogOpen, setConfirmCloseFormDialogOpen] = useState(false);

  const [data, setData] = useState(node?.data);

  console.debug('node data', node?.data);

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setConfirmCloseFormDialogOpen(false);
    console.debug('new data', data);
    const newNode = { ...node, data: data };
    console.debug('commit node', newNode);
    onNodeChanged(newNode);
  };

  const handleCancelClose = () => {
    setConfirmCloseFormDialogOpen(false);
  };

  const handleUpdateNode = useCallback((node) => {
    setData(node.data);
    console.debug('update node ' + node);
  }, []); // Dépendances vides car setData est stable

  return (
    <>
      <Drawer
        variant="temporary"
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
        TransitionComponent={Fade}
        transitionDuration={400}
        ModalProps={{
          keepMounted: false
        }}
        BackdropProps={{
          sx: { background: 'transparent' }
        }}
        PaperProps={{
          sx: { width: 700, p: 2, m: 0, top: '70px', borderRadius: 0 }
        }}
      >
        <Stack
          component="form"
          noValidate
          display="flex"
          direction="column"
          sx={{ height: '100%' }}
        >
          <Stack display="flex" direction="row" alignItems="center">
            {node?.data?.icon ? (
              <Icon sx={{ fontSize: '30px!important', mr: 1 }} color="primary">
                {node.data.icon}
              </Icon>
            ) : (
              <AssistantRoundedIcon color="text" fontSize="medium" sx={{ mr: 1 }} />
            )}

            <MDTypography variant="h5">Modification de '{node?.data?.label}'</MDTypography>
          </Stack>
          <Divider sx={{ mt: '0.5rem', mb: '0.75rem' }} />

          <NodeFormsFactory node={node} onUpdateData={handleUpdateNode} />
        </Stack>
      </Drawer>
      <Dialog open={confirmCloseFormDialogOpen} onClose={handleCancelClose}>
        <DialogTitle>{msg({ id: 'dialog.unsaved_changes.title' })}</DialogTitle>
        <DialogContent>
          <DialogContentText>{msg({ id: 'dialog.unsaved_changes.message' })}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleCancelClose} color="secondary">
            {msg({ id: 'button.cancel' })}
          </MDButton>
          <MDButton onClick={handleCloseDrawer} color="primary">
            {msg({ id: 'button.discard' })}
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );

  /* function handleUpdate(data) {}*/
}

NodeFormDetailsDrawer.propTypes = {
  node: PropTypes.object,
  drawerOpen: PropTypes.bool.isRequired,
  setDrawerOpen: PropTypes.func.isRequired,
  onNodeChanged: PropTypes.func.isRequired
};

export default NodeFormDetailsDrawer;
